module.exports = __webpack_public_path__ + "static/media/point_template.48322ad3.xlsx";